
import NavBar from "@/components/NavBar.vue";
import ReleaseNotesComp from "@/components/ReleaseNotesComp.vue";
import FooterSection from "@/components/FooterSection.vue";

import { ref, onMounted, onBeforeMount } from "vue";

export default {
  name: "ReleaseNotesPage",
  components: {
    NavBar,
    ReleaseNotesComp,
    FooterSection,
  },
  setup() {
    const windowSize = ref({});
    const scrollPosition = ref(0);

    function updateScroll() {
      scrollPosition.value = window.scrollY;
    }

    onMounted(() => {
      window.addEventListener("scroll", updateScroll);
    });

    onBeforeMount(() => {
      windowSize.value = window.innerWidth;
    }),
      window.addEventListener("resize", () => {
        windowSize.value = window.innerWidth;
      });

    return {
      scrollPosition,
      updateScroll,
      windowSize,
    };
  },
};
